import { css } from '@emotion/react';

import { css as globalCss, theme } from 'global';

const DEFAULT_ROW_HEIGHT_IN_PX = 56;

const tableCell = css`
  height: ${DEFAULT_ROW_HEIGHT_IN_PX}px;
  padding: 8px 24px;
  color: ${theme.colors.primary.dark};
  font-size: ${theme.fontSizes.body2};
  line-height: ${theme.lineHeights.body2};
  letter-spacing: ${theme.letterSpacings.body2};

  ${globalCss.ellipsisOverflow}

  @media screen and (max-width: 1395px) {
    padding: 16px;
  }
`;

export const tableHead = css`
  > .MuiTableRow-root {
    background-color: ${theme.colors.neutral[0]};

    & > .MuiTableCell-root {
      border-bottom: none;
      ${tableCell}
    }

    &:not(:first-of-type) > .MuiTableCell-root {
      border-top: 1px solid ${theme.colors.neutral[200]};
    }
  }
`;

export const tableBody = css`
  > .MuiTableRow-root {
    & > .MuiTableCell-root {
      ${tableCell}
    }

    &.Mui-selected {
      background-color: ${theme.colors.primary.lightest};
    }
  }
`;

// Ensures each column width in the table is fixed regardless of header change (from selection toolbar to regular table header)
export const table = css`
  table-layout: fixed;
`;

export const tableHeader = css`
  display: flex;
  align-items: center;
`;

export const selectAllCheckbox = css`
  color: ${theme.colors.primary.medium};
`;

export const selectAllToolbar = css`
  vertical-align: start;

  & .MuiTypography-root:not(.MuiButton-label, .MuiLink-root) {
    display: inline;
    font-weight: 400;
    color: ${theme.colors.neutral[500]};
  }

  .MuiLink-root {
    height: 20px;
    display: inline-flex;
    align-items: flex-end;
  }
`;

export const wrapText = (wrap = false) => css`
  &.MuiTableCell-root.MuiTableCell-head {
    ${wrap ? 'white-space: pre-wrap;' : ''}
  }
`;

export const underlinedLinks = (withLeftMargin = false) => css`
  text-decoration: underline;
  ${withLeftMargin ? 'margin-left: 24px;' : ''}
`;

export const checkbox = css`
  text-overflow: unset !important;
  width: 88px;
`;

export const toggle = css`
  margin-left: 0;
`;

export const emptyRows = (emptyRowsCount) => css`
  height: ${DEFAULT_ROW_HEIGHT_IN_PX * emptyRowsCount}px;
`;

export const tooltip = css`
  margin-left: 4px;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const loading = css`
  border: none;

  &.MuiTableCell-root {
    height: ${DEFAULT_ROW_HEIGHT_IN_PX}px;
  }
`;
